import { showFailed } from "../../CommonFunction/SweetAlert";
import { QuerySelector } from "./QuerySelector";

export const DashboardDetails = async (jwtToken, bankID, branchID, role) => {
  let query;
  if (role === "admin") {
    query = `bank_id=${bankID}&branch_id=${branchID}`;
  } else {
    query = `bank_id=${bankID}`;
  }
  try {
    const response = await fetch(
      `${process.env.REACT_APP_PLATFORM_API_BASE_URL}/dashboard/bank/loan-details?${query}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data?.response?.data;
    } else {
      showFailed(`Failed to get the data`, `${response.statusText}`);
    }
  } catch (error) {
    showFailed("Failed to load data.", error);
  }
};

// export const NotificationDetails = async (jwtToken, bankID, branchID, role) => {
//   let query;
//   if (role === "admin") {
//     query = `bank_id=${bankID}&branch_id=${branchID}`;
//   } else {
//     query = `bank_id=${bankID}`;
//   }
//   try {
//     const response = await fetch(
//       `${process.env.REACT_APP_PLATFORM_API_BASE_URL}/dashboard/bank/notification?${query}`,
//       {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${jwtToken}`,
//         },
//       }
//     );
//     if (response.ok) {
//       const data = await response.json();
//       return data;
//     } else {
//       showFailed(`Failed to get the data`, `${response.statusText}`);
//     }
//   } catch (error) {
//     showFailed("Failed to load data.", error);
//   }
// };

export const NotificationDetails = async (jwtToken, bankID, branchID, role, date) => {
  let query;
  if (role === "admin") {
    query = `bank_id=${bankID}&branch_id=${branchID}`;
  } else {
    query = `bank_id=${bankID}`;
  }
  try {
    const response = await fetch(
      `${process.env.REACT_APP_PLATFORM_API_BASE_URL}/dashboard/bank/overdue-loans-notification?${query}&targetDate=${date}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );
    const data = await response.json();
    if (response.ok) {
      return data;
    } else {
      return data;
    }
  } catch (error) {
    showFailed("Failed to load data.", error);
  }
};

export const PODNotification = async (jwtToken, date) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_PLATFORM_API_BASE_URL}/dashboard/bank/pod/notification?targetDate=${date}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );
    const data = await response.json();
    if (response.ok) {
      return data;
    } else {
      return data;
    }
  } catch (error) {
    showFailed("Failed to load data.", error);
  }
};

export const DefaultLoanAcc = async (
  isExport,
  jwtToken,
  paginationData,
  searchQuery,
  bankID,
  branchID,
  role
) => {
  try {
    const query = QuerySelector(
      isExport,
      paginationData,
      searchQuery,
      bankID,
      branchID,
      role
    );
    const response = await fetch(
      `${process.env.REACT_APP_PLATFORM_API_BASE_URL}/dashboard/bank/overdue-loans?${query}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );
    const data = await response.json();
    if (response.ok) {
      return data?.response?.data?.response;
    } else {
      showFailed(`Failed.`, `${data?.response?.message}`);
    }
  } catch (error) {
    showFailed("Failed to load data.", error);
  }
};

export const NPALoansAcc = async (
  isExport,
  jwtToken,
  paginationData,
  searchQuery,
  bankID,
  branchID,
  role
) => {
  try {
    const query = QuerySelector(
      isExport,
      paginationData,
      searchQuery,
      bankID,
      branchID,
      role
    );
    const response = await fetch(
      `${process.env.REACT_APP_PLATFORM_API_BASE_URL}/dashboard/bank/default-npa?${query}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );
    const data = await response.json();
    if (response.ok) {
      return data?.response?.data?.response;
    } else {
      showFailed(`Failed.`, `${data?.response?.message}`);
    }
  } catch (error) {
    showFailed("Failed to load data.", error);
  }
};

export const KYCDefaultUser = async (
  isExport,
  jwtToken,
  paginationData,
  searchQuery,
  bankID,
  branchID,
  role
) => {
  try {
    const query = QuerySelector(
      isExport,
      paginationData,
      searchQuery,
      bankID,
      branchID,
      role
    );
    const response = await fetch(
      `${process.env.REACT_APP_PLATFORM_API_BASE_URL}/dashboard/bank/kyc-default?${query}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );
    const data = await response.json();
    if (response.ok) {
      return data?.response?.data?.response;
    } else {
      showFailed(`Failed.`, `${data?.response?.message}`);
    }
  } catch (error) {
    showFailed("Failed to load data.", error);
  }
};

export const NoticeDeliveryDefault = async (
  isExport,
  jwtToken,
  paginationData,
  searchQuery,
  bankID,
  branchID,
  role
) => {
  try {
    const query = QuerySelector(
      isExport,
      paginationData,
      searchQuery,
      bankID,
      branchID,
      role
    );
    const response = await fetch(
      `${process.env.REACT_APP_PLATFORM_API_BASE_URL}/dashboard/bank/delivery-default-notice?${query}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      }
    );
    const data = await response.json();
    if (response.ok) {
      return data?.response?.data;
    } else {
      showFailed(`Failed.`, `${data?.response?.message}`);
    }
  } catch (error) {
    showFailed("Failed to load data.", error);
  }
};
